import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';


Vue.use(Vuex)
export const store = new Vuex.Store({
    state:{
        usernameTxt:"",
        passwordTxt:"",
        isLogin:false,
        accountInfo:"",
        trans_hist:[],
        fail_trans_hist:[]

    },
    plugins:[createPersistedState()],
    mutations:{
        setLogin(state,isLogin){
            state.isLogin=isLogin;
            return state.isLogin;
        },
        setUsername(state,usernameTxt){
            state.usernameTxt=usernameTxt;
        },
        setPassword(state,passwordTxt){
            state.passwordTxt=passwordTxt;
        },
        setAccountInfo(state,info){
            state.accountInfo=info;
        },
        setTranhist(state,trans_hist){
            state.trans_hist=trans_hist;
        },
        setFailtranshist(state,fail_trans){
            state.fail_trans_hist=fail_trans;
        }


    },
    getters:{
        isLogin:state=>state.isLogin,
        usernameTxt:state=>state.usernameTxt,
        passwordTxt:state=>state.passwordTxt,
        accountInfo:state=>state.accountInfo,
        trans_hist:state=>state.trans_hist,
        fail_trans_hist:state=>state.fail_trans_hist
    }
});